// ======================================================================
// File Name       : RegisterUserDialogContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import { Form } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';
import Header from '../../components/Header';
import RegisterUserSearch from '../../components/messageThread/RegisterUserSearch';
import UserListOnDialog from '../../components/messageThread/UserListOnDialog';
import * as MessageThreadAction from '../../actions/MessageThreadAction';
import * as GroupAction from '../../actions/GroupAction';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../constants/index';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { USER_TYPE } from '../../constants/UserConstants';
import { checkUserChecked } from '../../utils/index';

class RegisterUserDialogContainer extends React.Component {
  constructor(props) {
    super(props);
    this.addUsersToList = this.addUsersToList.bind(this);
    this.searchUser = this.searchUser.bind(this);
    this.searchUserOnSubmit = this.searchUserOnSubmit.bind(this);
    this.initData = this.initData.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.getModalOptions = this.getModalOptions.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.removeSelectedGroup = this.removeSelectedGroup.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(GroupAction.removeSelectedGroup());
    this.initData();
  }

  componentWillUnmount() {
    this.props.dispatch(MessageThreadAction.removedUserOnDialog());
  }

  initData() {
    const searchInfo = {
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
      userType: USER_TYPE.STUDENT,
    };
    this.props.dispatch(MessageThreadAction.initDataForDialog(searchInfo));
  }

  searchUser(startPosition, column) {
    const { formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    const param = this.createParams(formValues, startPosition, column);
    this.props.dispatch(MessageThreadAction.searchUserOnDialog(param));
  }

  createParams(searchInfo, startPosition, column) {
    const paramSearchInfo = {};
    paramSearchInfo.returnMaxNum = RETURN_MAX_NUM;
    paramSearchInfo.userType = USER_TYPE.STUDENT;
    if (searchInfo && Object.keys(searchInfo).length) {
      searchInfo.loginId && (paramSearchInfo.loginId = searchInfo.loginId);
      searchInfo.userName && (paramSearchInfo.userName = searchInfo.userName);
      if (searchInfo.selectedTargetGroup && searchInfo.selectedTargetGroup.groupSecernId) {
        paramSearchInfo.groupSecernId = searchInfo.selectedTargetGroup.groupSecernId;
      }
      paramSearchInfo.startPosition = searchInfo.startPosition || 0;
    }
    if (!isNaN(parseInt(startPosition, 10))) {
      paramSearchInfo.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      paramSearchInfo.ascendingDescendingSort = column.sortState;
      paramSearchInfo.messageSortType = column.sortBy;
    }
    return paramSearchInfo;
  }

  getStartEndData(startPosition) {
    const { invalid } = this.props;
    if (invalid) return;
    this.searchUser(startPosition);
  }

  handleSortState(column) {
    const { invalid } = this.props;
    if (invalid) return;
    this.searchUser(null, column);
  }

  searchUserOnSubmit(values) {
    const { invalid } = this.props;
    if (invalid || !values) {
      return;
    }
    const param = this.createParams(values, null, null);
    this.props.dispatch(MessageThreadAction.searchUserOnDialog(param));
  }

  addUsersToList() {
    const { edittingUserList, dispatch, hideModal } = this.props;
    const userChecked = checkUserChecked(edittingUserList);
    // #6576 START
    if (userChecked && userChecked.length === 0) {
      this.props.dispatch(change('registerMessageThreadForm', 'edittingUserList', {}));
    }
    // #6576 END
    dispatch(MessageThreadAction.addUsersToList(userChecked));
    dispatch(hideModal());
  }

  closeModal() {
    const { initial: { edittingUserList } } = this.props;
    this.props.dispatch(change('registerMessageThreadForm', 'edittingUserList', edittingUserList));
    this.props.dispatch(this.props.hideModal());
  }

  removeSelectedGroup() {
    this.props.dispatch(change('searchUserForm', 'selectedTargetGroup', null)); // Step 10.0.0
    this.props.dispatch(GroupAction.removeSelectedGroup());
  }

  getModalOptions() {
    return {
      title: '',
      footerBtns: [
        { name: 'キャンセル', onClick: this.closeModal, variant:'default' },
        {
          name: 'OK',
          onClick: this.addUsersToList,
          variant: 'primary',
        },
      ],
    };
  }

  handleCheckAll() {
    const { userListOnDialog, initial, edittingUserList } = this.props;
    const userChecked = checkUserChecked(edittingUserList, userListOnDialog);
    if (userListOnDialog && userListOnDialog.length) {
      userListOnDialog.map((user) => {
        const { userSecernId } = user;
        if (userSecernId && edittingUserList && !edittingUserList[userSecernId]) {
          this.props.dispatch(change('registerMessageThreadForm', `edittingUserList.${userSecernId}`, true));
        }
        if (edittingUserList && edittingUserList[userSecernId]) {
          if (userChecked.length === userListOnDialog.length && !initial.edittingUserList[userSecernId]) {
            this.props.dispatch(change('registerMessageThreadForm', `edittingUserList.${userSecernId}`, false));
          }
        }
      });
    }
  }

  render() {
    const { recordNumOnDialog, userListOnDialog, edittingUsers } = this.props;
    return (
      <ModalWrapper temporaryHide={''} {...this.getModalOptions()} hideModal={this.closeModal}>
        <div>
          <Header name="メッセージを送信するユーザーを選択してください" />
          <RegisterUserSearch
            onSearchBtnClick={this.searchUser}
            onSubmit={this.searchUserOnSubmit}
            removeSelectedGroup={this.removeSelectedGroup}
            recordNum={recordNumOnDialog}
            getStartEndData={this.getStartEndData}
            handleCheckAll={this.handleCheckAll}
          />
          <UserListOnDialog
            userList={userListOnDialog}
            edittingUsers={edittingUsers}
            recordNum={recordNumOnDialog}
            getStartEndData={this.getStartEndData}
          />
        </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { registerMessageThreadForm, registerUserForm } = state.form;
  const { initial, values } = registerMessageThreadForm;
  const { userListOnDialog, recordNumOnDialog, groupList, edittingUsers } = state.messageThread;
  let edittingUserList = {};
  if (registerMessageThreadForm && registerMessageThreadForm.values) {
    edittingUserList = registerMessageThreadForm.values.edittingUserList;
  }
  return {
    userListOnDialog,
    edittingUserList,
    edittingUsers,
    registerMessageThreadForm,
    registerUserForm,
    recordNumOnDialog,
    initial,
    values,
    groupList,
    formValues: getFormValues('searchUserForm')(state),
  };
};

export default connect(mapStateToProps)(RegisterUserDialogContainer);
